import { AppVersion } from 'client/modules/app/components/AppVersion';

export function InitialLoadOverlayExtraContent() {
  return <AppVersion className="absolute right-2 bottom-2 text-xs" />;
}
